module.exports = __webpack_public_path__ + "static/media/smart_lock.297978fd.png";